const TAX_ADVANTAGE_ACCOUNTS = [
    "IRA",
    "Roth IRA",
    "Sep IRA",
    "Inherited IRA",
    "Inherited Roth IRA",
];
export const UNKNOWN_ACCOUNT = "Unknown account";
export const UNKNOWN_BALANCE = "- -";
export const MASK_NUMBER = "****";
export const BANKING = "Banking";
export const isTaxAdvantageAccount = (account) => {
    return TAX_ADVANTAGE_ACCOUNTS.includes(account.accountDetails.accountType);
};
export const isManualAccount = (account) => {
    return account.accountProvider === "Manual";
};
export const isPlaidAccount = (account) => {
    return account.accountProvider === "Plaid";
};
export const isPlaidAccountV1 = (account) => {
    return account.accountProvider === "plaid";
};
export const isManualAccountV1 = (account) => {
    return account.accountProvider === "manual";
};
export const isExternalAccount = (account) => {
    return "connectionHealthType" in account && "availableBalance" in account;
};
export const isExtendedAccountHealthy = (account) => {
    return isPlaidAccount(account)
        ? account.details?.account.connectionHealthType === "Healthy"
        : false;
};
export const getAccountName = (account) => {
    return isManualAccountV1(account) || isManualAccount(account)
        ? (account.details?.account.accountTitle ?? UNKNOWN_ACCOUNT)
        : (account.details?.account.name ?? UNKNOWN_ACCOUNT);
};
export const getBankName = (account) => {
    if (account === undefined) {
        return UNKNOWN_ACCOUNT;
    }
    return isManualAccountV1(account) || isManualAccount(account)
        ? (account.details?.bank?.name ?? UNKNOWN_ACCOUNT)
        : (account.details?.institution?.name ?? UNKNOWN_ACCOUNT);
};
export const getAccountBalance = (account) => {
    return isPlaidAccount(account) ? getExternalAccountBalance(account) : null;
};
export const getAccountBalanceString = (account) => {
    const accountBalanceNumber = getAccountBalance(account);
    return accountBalanceNumber !== null
        ? accountBalanceNumber.toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
        })
        : UNKNOWN_BALANCE;
};
export const getAccountType = (account) => {
    return account.details?.account.accountType === "depository"
        ? BANKING
        : (account.details?.account.accountType ?? UNKNOWN_ACCOUNT);
};
export const getPartialAccountNumber = (account) => {
    const details = account.details?.account;
    const accountNumber = details === undefined
        ? null
        : "accountNumberMask" in details
            ? details.accountNumberMask
            : details.accountNumber;
    const normalizedNumber = accountNumber ?? MASK_NUMBER;
    return `${normalizedNumber.slice(-4).toUpperCase()}`;
};
export const getExternalAccountBalance = (account, ignoreHealth = false) => {
    const { available, current } = isExternalAccount(account)
        ? {
            available: ignoreHealth
                ? account.availableBalance
                : account.connectionHealthType === "Healthy"
                    ? account.availableBalance
                    : null,
            current: ignoreHealth
                ? account.currentBalance
                : account.connectionHealthType === "Healthy"
                    ? account.currentBalance
                    : null,
        }
        : isPlaidAccountV1(account) || isPlaidAccount(account)
            ? {
                available: ignoreHealth &&
                    account.details?.account.availableBalance !== undefined
                    ? account.details?.account.availableBalance
                    : account.details?.account.connectionHealthType === "Healthy" ||
                        account.details?.account.connectionHealthType === "healthy"
                        ? account.details?.account.availableBalance
                        : null,
                current: ignoreHealth &&
                    account.details?.account.currentBalance !== undefined
                    ? account.details?.account.currentBalance
                    : account.details?.account.connectionHealthType === "Healthy" ||
                        account.details?.account.connectionHealthType === "healthy"
                        ? account.details?.account.currentBalance
                        : null,
            }
            : { available: null, current: null };
    if (available === null && current === null) {
        return null;
    }
    // We want to show the current balance (amount spent) for credit cards not
    // total available credit
    if (isExternalAccount(account)) {
        const accountType = account.accountType;
        if (accountType === "credit" || accountType === "loan") {
            return current ?? available;
        }
    }
    else if (isPlaidAccountV1(account) || isPlaidAccount(account)) {
        const accountType = account.details?.account.accountType ?? null;
        if (accountType === "credit" || accountType === "loan") {
            return current ?? available;
        }
    }
    return current ?? available;
};
//# sourceMappingURL=accountUtil.js.map